import React from 'react';
import { BallTriangle  } from 'react-loader-spinner';
// const loading = require('../../assets/images/loading.gif');

const Loader = (props) => {
    if (props?.visible)
        // if(true)
        return (
            <div className='loader_section'>
                <BallTriangle
                    height={100}
                    width={150}
                    radius={5}
                    color="#087d82"
                    secondaryColor= '#4fa94d'
                    ariaLabel="ball-triangle-loading"
                    wrapperClass={{}}
                    wrapperStyle={{}}
                    visible={true}
                />
                {/* <img src={loading} style={{height:100, width:100, backgroundColor:'transparent'}} /> */}
            </div>
        )
    else
        return null;
}

export default Loader;